import { render } from "./FinishAttendantModal.vue?vue&type=template&id=0b1664c9"
import script from "./FinishAttendantModal.vue?vue&type=script&lang=js"
export * from "./FinishAttendantModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__